import React from "react";
import { Link, useLocation } from "react-router-dom";
import RouteScrollManager from "./RouteScrollManager";
import styles from "./SiteShell.module.css";
import {
  LOCALE_OPTIONS,
  getBrowserLocale,
  getLocalizedPath,
  translate,
} from "./i18n";

function classNames(...values) {
  return values.filter(Boolean).join(" ");
}

function SiteShell({ children, locale }) {
  const location = useLocation();
  const activeLocale = locale || getBrowserLocale();
  const t = (key, values) => translate(activeLocale, key, values);
  const localPath = (path) => getLocalizedPath(path, activeLocale);
  const isGalleryPage =
    !location.pathname.includes("/view") &&
    !location.pathname.includes("/ausmalbild/");

  return (
    <div className={styles.shell}>
      <RouteScrollManager />
      <header className={styles.header}>
        <div className={styles.container}>
          <div className={styles.headerBar}>
            <Link className={styles.brand} to={localPath("/")}>
              <span className={styles.brandMark}>UM</span>
              <span className={styles.brandText}>
                <span className={styles.brandName}>usmalbilder.ch</span>
                <span className={styles.brandTagline}>
                  {t("siteTagline")}
                </span>
              </span>
            </Link>

            <nav className={styles.nav} aria-label={t("navGallery")}>
              <Link
                className={classNames(
                  styles.navLink,
                  isGalleryPage && styles.navLinkActive
                )}
                to={localPath("/")}
              >
                {t("navGallery")}
              </Link>
              <a className={styles.navLink} href={`${localPath("/")}#top-themen`}>
                {t("navTopics")}
              </a>
              <a className={styles.navLink} href={`${localPath("/")}#druck-tipps`}>
                {t("navPrint")}
              </a>
              <a className={styles.navLink} href={`${localPath("/")}#faq`}>
                {t("navFaq")}
              </a>
            </nav>

            <div className={styles.languageSwitcher} aria-label={t("languageLabel")}>
              {LOCALE_OPTIONS.map((item) => (
                <Link
                  className={classNames(
                    styles.languageLink,
                    item.code === activeLocale && styles.languageLinkActive
                  )}
                  key={item.code}
                  to={getLocalizedPath(location.pathname, item.code, {
                    forceLocalePrefix: item.code === "de",
                  })}
                  title={item.name}
                >
                  {item.code.toUpperCase()}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </header>

      <main className={styles.main}>
        <div className={styles.container}>{children}</div>
      </main>

      <footer className={styles.footer}>
        <div className={styles.container}>
          <div className={styles.footerBar}>
            <div>
              <p className={styles.footerCopy}>
                {t("footerCopy")}
              </p>
              <p className={styles.footerSubcopy}>
                {t("footerSubcopy")}
              </p>
            </div>
            <div className={styles.footerLinks}>
              <Link to={localPath("/tiere")}>{t("footerAnimals")}</Link>
              <Link to={localPath("/dino")}>{t("footerDinosaurs")}</Link>
              <Link to={localPath("/unicorn")}>{t("footerUnicorn")}</Link>
              <Link to={localPath("/ostern")}>{t("footerEaster")}</Link>
              <Link to={localPath("/ueber")}>{t("footerAbout")}</Link>
              <Link to={localPath("/so-entstehen-ausmalbilder")}>
                {t("footerHowMade")}
              </Link>
              <Link to={localPath("/nutzung-und-lizenz")}>
                {t("footerLicense")}
              </Link>
              <Link to={localPath("/drucktipps")}>{t("footerPrintTips")}</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default SiteShell;
